export const createBlPromptMessage =
  "¿Está séguro de crear el BL con los datos ingresados?";
export const editBlPromptMessage =
  "¿Está séguro de actualizar el BL con los nuevos datos ingresados?";

export const filterOptions = [
  {
    value: "cod_booking",
    label: "Booking",
  },
  {
    value: "cod_contenedor",
    label: "Num. Contendor",
  },
  {
    value: "estado_procesamiento",
    label: "Estado de procesamiento",
  },
  {
    value: "place_delivery",
    label: "Destino",
  },
  {
    value: "info_shipper",
    label: "Shipper",
  },
  {
    value: "info_consignee",
    label: "Consignee",
  },
];
